import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { GRAY, GRAY_LIGHT } from '../constants/Colors';

import Row from './Row';

export default () => (
  <Row style={styles.container}>
    <View style={styles.stripe} />
    <Text style={styles.orLabel}>OR</Text>
    <View style={styles.stripe} />
  </Row>
);

const styles = StyleSheet.create({
  container: { alignItems: 'center', marginVertical: 24 },
  stripe: {
    height: 1,
    backgroundColor: '#555555',
    flex: 1,
  },
  orLabel: {
    marginHorizontal: 7,
    color: GRAY_LIGHT,
    fontWeight: 'bold',
    fontSize: 12,
  },
});
